/**
 * 环境配置工具
 */
export const getEnv = (key, defaultValue = '') => {
  return import.meta.env[key] || defaultValue
}

// 根据环境获取API基础URL
// const getApiBaseUrl = () => {
//   const env = getEnv('VITE_APP_ENV', 'development')

//   switch (env) {
//     case 'production':
//       return getEnv('VITE_API_BASE_URL', '')
//     case 'testing':
//       return getEnv('VITE_API_BASE_URL', '/api') // 使用代理
//     case 'uat':
//       return getEnv('VITE_API_BASE_URL', '/api') // 使用代理
//     case 'development':
//     default:
//       return getEnv('VITE_API_BASE_URL', '/api') // 使用代理
//   }
// }


// 环境配置对象
export const env = {
  // 应用信息
  APP_TITLE: getEnv('VITE_APP_TITLE', 'Register App'),
  APP_ENV: getEnv('VITE_APP_ENV', 'development'),
  APP_VERSION: getEnv('VITE_APP_VERSION', '1.0.0'),

  // API配置
  // API_BASE_URL: '/api',

  API_BASE_URL: import.meta.env.PROD ? "" : "/api",

  // API_BASE_URL: import.meta.env.PROD ? getApiBaseUrl() : "/api",

  // API_BASE_URL: getApiBaseUrl(),

  API_BASE_URL_API: getEnv('VITE_API_BASE_URL'),

  // 调试配置
  DEBUG: getEnv('VITE_DEBUG', 'false') === 'true',

  // 是否为开发环境
  isDevelopment: getEnv('VITE_APP_ENV') === 'development',

  // 是否为生产环境
  isProduction: getEnv('VITE_APP_ENV') === 'production',

  // 是否为测试环境
  isTesting: getEnv('VITE_APP_ENV') === 'testing',

  // 是否为UAT环境
  isUAT: getEnv('VITE_APP_ENV') === 'uat',
}

// 导出默认配置
export default env
